import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { TiTicket } from 'react-icons/ti';
import { Button } from 'react-bootstrap';
import { Map } from 'immutable';
import styles from './style.scss';

const propTypes = {
  settings: PropTypes.instanceOf(Map).isRequired,
  event: PropTypes.instanceOf(Map).isRequired,
  className: PropTypes.string,
  forceButtonImage: PropTypes.bool,
};

function AttendButton({ settings, event, className = '', forceButtonImage }) {
  const text = settings.get('attendBtnText');
  const location = event.get('venue', '');
  if (settings.get('calendarType') === 'google' && location.startsWith('https://zoom')) {
    return (
      <a href={location} className={cn('attendee_button', className)}>
        {forceButtonImage ? (
          <ButtonImage className={className} text={text} />
        ) : (
          <Button
            className={cn({
              attendee_button: true,
              [styles.squareButtons]: true,
            })}
          >
            {text}
          </Button>
        )}
      </a>
    );
  }
  if (settings.get('calendarType') === 'google' && !location.startsWith('https://zoom')) {
    return <span />;
  }
  return (
    <a
      href={event.get('url')}
      rel="noopener noreferrer"
      className={cn('attendee_button', className)}
      target="_blank"
    >
      {forceButtonImage ? (
        <ButtonImage className={className} text={text} />
      ) : (
        <Button
          className={cn({
            [className]: true,
            attendee_button: true,
            [styles.squareButtons]: !settings.get('buttonRounded'),
            [styles.attendButton]: true,
          })}
        >
          {text}
        </Button>
      )}
    </a>
  );
}

function ButtonImage({ className, text }) {
  return (
    <span className="hint--bottom" aria-label={text}>
      <TiTicket
        className={cn('attendee_button', 'marginTop', className)}
        aria-label={text}
        size={30}
      />
    </span>
  );
}

AttendButton.propTypes = propTypes;
ButtonImage.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
};

export default AttendButton;



// WEBPACK FOOTER //
// ./src/widget/event_components/attend_button.js